import React, { useState } from 'react'
import Navbar from '../../components/Navbar'
import Footer from '../../components/Footer'
import ShopBanner from './ShopBanner'
import ShopCard from '../../components/ImageCard'
import caseStudiesData from '../../data/casestudies.json'

const ShopPage = () => {
  const [selectedCategory] = useState("all");

  return (
    <div className="page pt-20">
      <Navbar />
      <ShopBanner />
        <div className="px-10 py-12">
           <div>
            {/* <div className="flex flex-wrap gap-3">
                {categories.map((category) => (
                  <button
                    key={category.id}
                    onClick={() => handleCategoryClick(category.id)}
                    className={`rounded-full border-neutral-600 px-4 py-2 border text-sm font-medium cursor-pointer w-fit transition-all ${
                      selectedCategory === category.id
                        ? 'bg-neutral-800 text-[#e3eed1cc] border-[#e3eed1cc] '
                        : 'text-[#ECF2E1] bg-none hover:bg-neutral-800 hover:text-white'
                    }`}
                    title={category.description}
                  >
                    {category.name}
                  </button>
                ))}
            </div> */}
            
           </div> 
           <div>
            {/* Feed content goes here, filtered by selectedCategory */}
            {/* <p className="text-neutral-400 font-medium text-sm">{selectedCategory ? (categories.find(cat => cat.id === selectedCategory)?.description ?? 'All') : 'All'}</p> */}
            <div className="">
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                {caseStudiesData.caseStudies && caseStudiesData.caseStudies
                  .filter((item) => {
                    // show all when no category selected or when 'all' is selected
                    if (selectedCategory === 'all' || !selectedCategory) return true;
                    // try matching by type or brand or slug to category id
                    return [item.type, item.brand, item.slug].includes(selectedCategory);
                  })
                  .map((item, idx) => (
                    <ShopCard
                      key={item.slug || idx}
                      title={item.title}
                      description={item.summary || item.takeaways?.[0] || ''}
                      image={item.media?.screenshots?.[0]}
                      imageAlt={item.title}
                    />
                  ))}
              </div>
            </div>
           </div>
        </div>
        {/* Upcoming  */}
      <Footer/>
    </div>
  )
}

export default ShopPage